var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "parts",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.942,
    height: 20.942,
    viewBox: "0 0 20.942 20.942",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M1242.661,730.143l2.8-1.325-.609-1.9-3.049.554a7.686,7.686,0,0,0-2.09-2.468l1.044-2.916-1.772-.91-1.763,2.546a7.691,7.691,0,0,0-3.223-.263l-1.326-2.8-1.9.609.554,3.05a7.683,7.683,0,0,0-2.468,2.089l-2.916-1.044-.91,1.771,2.546,1.764a7.674,7.674,0,0,0-.263,3.223l-2.8,1.325.608,1.9,3.05-.554a7.7,7.7,0,0,0,2.09,2.468l-1.044,2.916,1.771.91,1.764-2.546a7.689,7.689,0,0,0,3.223.263l1.324,2.8,1.9-.609-.554-3.05a7.694,7.694,0,0,0,2.468-2.089l2.916,1.043.91-1.771-2.546-1.763a7.706,7.706,0,0,0,.263-3.223m-2.263,3.77a6.079,6.079,0,1,1-2.628-8.185,6.085,6.085,0,0,1,2.628,8.185",
    transform: "translate(-1224.521 -720.663)",
    fill: "none",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 30.942,
    height: 30.942,
    transform: "translate(-5 -5)",
    fill: "#404149"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParts);
export default __webpack_public_path__ + "static/media/parts.559c2144a02794bf19f57d657406c1f4.svg";
export { ForwardRef as ReactComponent };